import { useSyncExternalStore } from "react";

import {
  getAuthSessionSnapshot,
  subscribeAuthSession,
} from "@/lib/auth/session";
import DeveloperPortalPage from "@/pages/glofox/DeveloperPortalPage";
import LoginPage from "@/pages/LoginPage";

export default function HomePage() {
  const session = useSyncExternalStore(
    subscribeAuthSession,
    getAuthSessionSnapshot,
    getAuthSessionSnapshot,
  );

  if (!session) {
    return <LoginPage />;
  }

  return <DeveloperPortalPage session={session} />;
}
